module.exports = __webpack_public_path__ + "static/media/newRoomCreatedSound.3a77f1ed.wav";